import React from 'react';

export const CallLogsDrawerOutgoingCall = ({
  width = 20,
  height = 20,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16504 4.17253C3.94403 4.17253 3.73206 4.26032 3.57578 4.4166C3.42454 4.56784 3.33744 4.77123 3.33198 4.9845C3.52364 8.02111 4.81637 10.884 6.96832 13.0359C9.12027 15.1879 11.9831 16.4806 15.0197 16.6723C15.233 16.6668 15.4364 16.5797 15.5876 16.4284C15.7439 16.2722 15.8317 16.0602 15.8317 15.8392V13.0701L12.8478 11.8765L11.963 13.3513C11.7398 13.7232 11.2687 13.8617 10.8798 13.6699C8.90566 12.6963 7.30792 11.0986 6.33432 9.12445C6.14249 8.73549 6.28107 8.26442 6.65296 8.04128L8.12773 7.15642L6.93418 4.17253H4.16504ZM2.39727 3.23809C2.86611 2.76925 3.502 2.50586 4.16504 2.50586H7.49837C7.83913 2.50586 8.14555 2.71332 8.2721 3.0297L9.93877 7.19637C10.0907 7.57613 9.94452 8.01 9.59379 8.22044L8.19879 9.05744C8.88534 10.1771 9.82711 11.1189 10.9468 11.8054L11.7838 10.4104C11.9942 10.0597 12.4281 9.91356 12.8079 10.0655L16.9745 11.7321C17.2909 11.8587 17.4984 12.1651 17.4984 12.5059V15.8392C17.4984 16.5022 17.235 17.1381 16.7661 17.607C16.2973 18.0758 15.6614 18.3392 14.9984 18.3392C14.9815 18.3392 14.9647 18.3387 14.9478 18.3377C11.494 18.1278 8.2365 16.6611 5.78981 14.2144C3.34311 11.7677 1.87646 8.51018 1.66657 5.05641C1.66555 5.03958 1.66504 5.02272 1.66504 5.00586C1.66504 4.34282 1.92843 3.70693 2.39727 3.23809Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2543 2.74994C17.5797 3.07537 17.5797 3.60301 17.2543 3.92845L13.0876 8.09512C12.7622 8.42055 12.2346 8.42055 11.9091 8.09512C11.5837 7.76968 11.5837 7.24204 11.9091 6.9166L16.0758 2.74994C16.4012 2.4245 16.9289 2.4245 17.2543 2.74994Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4984 3.33919C12.4984 2.87896 12.8715 2.50586 13.3317 2.50586H16.665C17.1253 2.50586 17.4984 2.87896 17.4984 3.33919V6.67253C17.4984 7.13276 17.1253 7.50586 16.665 7.50586C16.2048 7.50586 15.8317 7.13276 15.8317 6.67253V4.17253H13.3317C12.8715 4.17253 12.4984 3.79943 12.4984 3.33919Z"
      fill="currentColor"
    />
  </svg>
);
